<template>

  <div class="rm" :ref="'rm_'+index">
        <div class="rm-form" >
          <div class="header-box">
            <div class="header-wrap">
              <h3 class="header">Register for High Speed Internet Access</h3>
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3" class="form">
            <div class="mb-15">
              <div class="row p-rel form-field">
                <label class="label">First Name</label>
                <input v-model="form.first_name" class="input-text" type="text" />
              </div>
              <div class="row p-rel form-field">
                <label class="label">Last Name</label>
                <input v-model="form.last_name" class="input-text" type="text" />
              </div>
              <div class="row p-rel form-field email">
                <div class="email-form">
                  <label class="label">Email Address</label>
                  <input v-model="form.email_address" class="input-text" type="text" />
                </div>
                <small class="required"><i>*Required</i></small>
              </div>
            </div>
            <label for="email_consent" class="text-left d-flex align-items-start">
              <input class="mr-10" type="checkbox" name="email_consent" id="email_consent" v-model="form.email_consent" />
              <span class="caps"><b>OPT IN TO RECEIVING MARKETING EMAILS FROM FREEHAND HOTELS.</b></span>
            </label>
            <label for="tos_consent" class="text-left d-flex align-items-start">
              <input class="mr-10" type="checkbox" name="tos_consent" id="tos_consent" v-model="form.tos_consent" />
              <span class="caps"><b>I AGREE TO THE </b><span @click="selectTermsOfService(index)" class=""><b class="text-link caps"><u>TERMS AND CONDITIONS</u></b></span></span>
            </label>
            <div class="pt-20 tos" v-if="selected_tos==index">
              <div v-html="registration_method.terms_of_service" class="tos"></div>
              <div class="mt-30 text-center"><button class="btn rounded close" @click="selectTermsOfService(null)">CLOSE</button></div>
            </div>
          </div>
          <div class="pt-20 mb-15">
            <button :disabled="!show_continue" @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">CONTINUE</button>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
import Axios from "axios";
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method','portal'],
  data(){
    return{
      clicked: false,
      form: {
        access_code: '',
        room_number: '',
        first_name: '',
        last_name: '',
        email_address: '',
        email_consent: false,
        tos_consent: false
      },
    }
  },
  computed: {
    show_continue:function(){
      const validEmail = /\S+@\S+\.\S+/.test(this.form.email_address);
      
      const email_method_2_ready = this.registration_method.registration_method_id === 2 && this.form.last_name && this.form.room_number;
      const email_method_3_ready = this.registration_method.registration_method_id === 3 && validEmail && this.form.tos_consent;
      const email_method_4_ready = this.registration_method.registration_method_id === 4 && this.form.access_code;
      return email_method_2_ready || email_method_3_ready || email_method_4_ready;
    },
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },

    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: async function(){
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        first_name: null, 
        last_name: null,
        room_number: null,
        access_code: null,
        email_opt_in: false
      };

      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_opt_in = this.form.email_consent;
        emitted.first_name = this.form.first_name;
        emitted.last_name = this.form.last_name;
        emitted.email_address = this.form.email_address;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.form.access_code;
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },
  }
}
</script>
<style scoped>
.header {
  text-align: left;
  margin: 0
}

.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 34rem;
}

.header-wrap {
  border-bottom: .05rem solid #A18E68;
  margin-bottom: 20px;
}

.form-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%
}

.text-link {
  color: #A18E68
}

.rm-form {
  padding: 20px 15px 10px 15px;
  background-color: #F5F5F5;
}

label {
  padding: 10px 30px 0px 0px
}

.label, .input-text {
  text-align: left;
  width: 8rem;
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.input-text {
  width: 15rem;
  padding: .5rem;
  margin: .1rem;
  border-radius: 0;
  width: 54%;
}

.caps {
  font-size: 14px;
}

.btn {
  background: #A18E68;
  color: #ffffff;
  font-size: 16px;
}

.close {
  background: white;
  color: black;
}

.btn.rounded {
  padding: 3px;
  border-radius: 0;
  margin: 0
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  cursor: not-allowed;
}

.rm {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #F5F5F5;
}

.required {
  color: black;

}

.email {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}

.email-form {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
